(function () {
  'use strict';

  const init = () => {

    const videos = document.querySelectorAll('.text-media__video');

    videos.forEach((video) => {
      video.addEventListener('play', () => {
        video.classList.add('is-playing');
      });

      video.addEventListener('pause', () => {
        video.classList.remove('is-playing');
      });

      video.addEventListener('ended', () => {
        video.classList.remove('is-playing');
      });

    })

  };

  window.addEventListener('load', init);
})();
